module.exports = __webpack_public_path__ + "img/team-worked-3.1229430e.png";